import React from 'react';
import PageHero from '../common/PageHero';
import { useTranslation } from 'react-i18next';

const IndustriesHero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageHero
      eyebrow={t('industriesSection.hero.eyebrow')}
      title={t('industriesSection.hero.title')}
      description={t('industriesSection.hero.description')}
      typedTitle
    />
  );
};

export default IndustriesHero;
